import React, { useState } from 'react';
import { MessageSquare, Send, MinimizeIcon, Maximize2Icon, Upload, Database, ArrowRight } from 'lucide-react';
const suggestions = ['Show products with compliance issues', 'Summarize supplier performance', 'Generate compliance report', 'Check latest product updates'];
const recommendedActions = [{
  title: 'Analyze Compliance Status',
  description: 'Upload product data for comprehensive compliance analysis',
  steps: '2 steps',
  icon: Database
}, {
  title: 'Generate Performance Report',
  description: 'Create detailed supplier performance assessment',
  steps: '1 step',
  icon: Upload
}, {
  title: 'Review Product Claims',
  description: 'Validate and verify product certification claims',
  steps: '2 steps',
  icon: MessageSquare
}];
export function AIAssistant() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [inputValue, setInputValue] = useState('');
  return <div className={`bg-white border rounded-lg m-8 transition-all duration-300 ${isCollapsed ? 'h-16' : ''}`} data-id="element-18">
      <div className="p-6" data-id="element-19">
        <div className="flex items-center justify-between mb-6" data-id="element-20">
          <div className="flex items-center space-x-3" data-id="element-21">
            <div className="bg-purple-100 p-2 rounded-lg" data-id="element-22">
              <MessageSquare className="w-6 h-6 text-purple-600" data-id="element-23" />
            </div>
            <div data-id="element-24">
              <h2 className="font-semibold text-xl text-gray-900" data-id="element-25">
                Scoop AI Assistant
              </h2>
              <p className="text-sm text-gray-600" data-id="element-26">
                Ask complex questions about your products and compliance
              </p>
            </div>
          </div>
          <button onClick={() => setIsCollapsed(!isCollapsed)} className="text-gray-500 hover:text-gray-700" data-id="element-27">
            {isCollapsed ? <Maximize2Icon className="w-5 h-5" data-id="element-28" /> : <MinimizeIcon className="w-5 h-5" data-id="element-29" />}
          </button>
        </div>
        {!isCollapsed && <>
            <div className="grid grid-cols-2 gap-6 mb-6" data-id="element-30">
              <div className="border rounded-lg p-4 hover:border-purple-300 cursor-pointer transition-colors" data-id="element-31">
                <h3 className="font-medium mb-1" data-id="element-32">Upload files</h3>
                <p className="text-sm text-gray-600" data-id="element-33">
                  Analyze product documentation or compliance reports
                </p>
              </div>
              <div className="border rounded-lg p-4 hover:border-purple-300 cursor-pointer transition-colors" data-id="element-34">
                <h3 className="font-medium mb-1" data-id="element-35">Choose knowledge source</h3>
                <p className="text-sm text-gray-600" data-id="element-36">
                  Product database, compliance guidelines, and more
                </p>
              </div>
            </div>
            <div className="mb-6" data-id="element-37">
              <div className="relative" data-id="element-38">
                <input type="text" placeholder="Ask Scoop AI anything..." value={inputValue} onChange={e => setInputValue(e.target.value)} className="w-full px-4 py-3 pr-10 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-39" />
                <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-purple-600 hover:text-purple-700" data-id="element-40">
                  <Send className="w-5 h-5" data-id="element-41" />
                </button>
              </div>
              <div className="flex gap-2 mt-3 overflow-x-auto" data-id="element-42">
                {suggestions.map((suggestion, index) => <button key={index} className="flex-shrink-0 px-3 py-1.5 text-sm bg-purple-50 text-purple-600 rounded-full hover:bg-purple-100" data-id="element-43">
                    {suggestion}
                  </button>)}
              </div>
            </div>
            <div data-id="element-44">
              <div className="flex items-center justify-between mb-4" data-id="element-45">
                <h3 className="font-medium text-gray-900" data-id="element-46">
                  Recommended Actions
                </h3>
                <button className="text-sm text-purple-600 hover:text-purple-700" data-id="element-47">
                  See all
                </button>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-48">
                {recommendedActions.map((action, index) => <div key={index} className="border rounded-lg p-4 hover:border-purple-300 cursor-pointer transition-colors" data-id="element-49">
                    <div className="bg-purple-50 w-10 h-10 rounded-lg flex items-center justify-center mb-3" data-id="element-50">
                      <action.icon className="w-5 h-5 text-purple-600" data-id="element-51" />
                    </div>
                    <h4 className="font-medium mb-1" data-id="element-52">{action.title}</h4>
                    <p className="text-sm text-gray-600 mb-3" data-id="element-53">
                      {action.description}
                    </p>
                    <div className="flex items-center text-sm text-gray-500" data-id="element-54">
                      <span data-id="element-55">{action.steps}</span>
                      <ArrowRight className="w-4 h-4 ml-2" data-id="element-56" />
                    </div>
                  </div>)}
              </div>
            </div>
          </>}
      </div>
    </div>;
}